export default __webpack_public_path__ + "static/media/green_copy_icon.3a733fd5.svg";